import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 16px;
  box-shadow: 10px 10px 20px 0 rgba(0, 0, 0, 0.04);
  gap: 16px;
  border-radius: 8px;
  position: absolute;
  background-color: white;
  z-index: 10;
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: flex;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    position: unset;
  }
`;

export const IconWrapper = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  & svg {
    width: ${32 / 16}rem;
    height: ${32 / 16}rem;
  }
`;

export const TitleDescriptionWrapper = styled.div`
  font-family: "Mulish", sans-serif;
`;

export const Title = styled.p`
  font-size: ${12 / 16}rem;
  color: ${(props) => props.theme.palette.greyscale.grey300};
  font-weight: 400;
`;

export const Description = styled.h6`
  margin-top: 4px;
  font-weight: 700;
  font-size: ${24 / 16}rem;
  color: ${(props) => props.theme.palette.primary.blue900};
`;
